// extracted by mini-css-extract-plugin
module.exports = {"c-select":"select_c-select__KURcT","joyfully-bold":"select_joyfully-bold__EFPVN"};